import { $api } from "../../contants/API";
import { createModel } from "@rematch/core";
import { RootModel } from "../modals";
import { initialState } from "./state";
import { GetOrders, getOrderListType } from "./type";
import { toast } from "react-toastify";

export const orderSlice = createModel<RootModel>()({
  state: initialState,
  reducers: {
    getOrders: (state, payload: GetOrders[]) => {
      return {
        ...state,
        ordersList: payload,
      };
    },
    getDetailOrderFunction: (state, payload: getOrderListType) => {
      return {
        ...state,
        orderDetail: payload,
      };
    },
    getAllOrdersFuntion: (state, payload) => {
      return {
        ...state,
        getAllOrders: payload,
      };
    },
    getOrderListFunction: (state, payload: getOrderListType) => {
      return {
        ...state,
        getOrderList: payload,
      };
    },
    isResultFunction: (state, payload) => {
      return {
        ...state,
        toast: payload,
      };
    },
  },

  effects: (dispatch) => ({
    async orderSend(payload) {
      try {
        const { data } = await $api.post("v1/order/send", payload.data);
        await dispatch.profileSlice.getUser();
        await dispatch.orderSlice.getOrderListFunction(data.data);
        await payload.callback?.();
        await dispatch.orderSlice.isResultFunction(true);
      } catch (e) {
        toast.error("У пользователя недостаточно лимита");
      }
    },
    async getOrderLoad() {
      try {
        const { data } = await $api.get("v1/user-transaction/index");
        dispatch.orderSlice.getOrders(data.data.data);
        dispatch.orderSlice.getAllOrdersFuntion(data.data);
      } catch (e) {}
    },
    async getDetailOrder(id) {
      try {
        const { data } = await $api.get(`v1/order/detail?id=${id}`);
        dispatch.orderSlice.getDetailOrderFunction(data?.data);
      } catch (e) {}
    },
  }),
});
